import { render, staticRenderFns } from "./RoleMenuTree.vue?vue&type=template&id=5f20b58d&scoped=true"
import script from "./RoleMenuTree.vue?vue&type=script&lang=js"
export * from "./RoleMenuTree.vue?vue&type=script&lang=js"
import style0 from "./RoleMenuTree.vue?vue&type=style&index=0&id=5f20b58d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20b58d",
  null
  
)

export default component.exports